export default class IdbClass {
  private DB_NAME = 'jcudb';
  private DB_VERSION = 1;
  private DB: any;

  async getDb() {
    return new Promise((resolve, reject) => {
      if (this.DB) {
        return resolve(this.DB);
      }

      const request = window.indexedDB.open(this.DB_NAME, this.DB_VERSION);

      request.onerror = () => {
        reject('Error');
      };

      request.onsuccess = (e: any) => {
        this.DB = e?.target?.result;
        resolve(this.DB);
      };

      request.onupgradeneeded = (e: any) => {
        const db = e.target.result;
        db.createObjectStore('projects', { autoIncrement: false, keyPath: 'idbId' });
      };
    });
  }

  public async deleteProject() {
    const db = (await this.getDb()) as any;

    return new Promise<void>(resolve => {
      const trans = db.transaction(['projects'], 'readwrite');
      trans.oncomplete = () => {
        resolve();
      };

      const store = trans.objectStore('projects');
      store.clear();
    });
  }

  public async saveProject(project: any) {
    const db = (await this.getDb()) as any;

    return new Promise<void>(resolve => {
      const trans = db.transaction(['projects'], 'readwrite');
      trans.oncomplete = () => {
        resolve();
      };

      const store = trans.objectStore('projects');
      store.put(project);
    });
  }

  public async getProject() {
    const db = (await this.getDb()) as any;

    return new Promise(resolve => {
      let project = {};

      const trans = db.transaction(['projects'], 'readonly');
      trans.oncomplete = () => {
        resolve(project);
      };

      const store = trans.objectStore('projects');

      store.getAll().onsuccess = (e: any) => {
        project = e.target.result[0];
      };
    });
  }
}
